import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { Block as BlockIcon } from '@mui/icons-material';

const MotivoRechazoModal = ({
  open,
  onClose,
  onConfirm,
  motivoActual = '',
  loading = false
}) => {
  const [motivo, setMotivo] = useState(motivoActual || '');
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setMotivo(motivoActual || '');
      setError('');
    }
  }, [open, motivoActual]);

  const handleConfirm = () => {
    if (!motivo.trim()) {
      setError('El motivo del rechazo es obligatorio');
      return;
    }
    setError('');
    onConfirm(motivo.trim());
  };

  const handleMotivoChange = (e) => {
    setMotivo(e.target.value);
    if (error) setError('');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <BlockIcon color="error" />
          <Typography variant="h6">
            Motivo de Rechazo Requerido
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" sx={{ mb: 3 }}>
          Para cambiar la iniciativa al estado <strong>Rechazada</strong> es necesario
          especificar el motivo del rechazo.
        </Alert>

        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            Por favor, indica el motivo por el que se rechaza esta iniciativa:
          </Typography>

          <TextField
            fullWidth
            label="Motivo del rechazo"
            value={motivo}
            onChange={handleMotivoChange}
            error={!!error}
            helperText={error || 'Describe brevemente el motivo del rechazo'}
            placeholder="Ej: Presupuesto insuficiente, falta de recursos técnicos..."
            disabled={loading}
            variant="outlined"
            multiline
            rows={3}
            sx={{ mb: 2 }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
        >
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={loading || !motivo.trim()}
          variant="contained"
          color="error"
          startIcon={loading && <CircularProgress size={20} />}
        >
          {loading ? 'Guardando...' : 'Guardar y Rechazar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MotivoRechazoModal;
